const messages = {
  threads: {
    orders: { title: "", content: "" },
    externalTraining: { title: "", content: "" },
    InvestmentSupport: { title: "", content: "" },
    onlineTraining: { title: "", content: "" },
    bTraining: { title: "", content: "" },
    hunter: { title: "", content: "" },
    profileComplete: { title: "", content: "" },
    activeUser: { title: "", content: "" },
    deleteItemFromOrder: { title: "", content: "" },
    deleteOrder: { title: "", content: "" },
    commitmentLetter: {
      title: "Paldies par reģistrēšanos",
      content:
        "Cienījamais,<br/>Paldies par reģistrēšanos. Mēs ar prieku informējam, ka jūsu reģistrācija BRIDGESTONE PLUS ir pārskatīta un apstiprināta.<br/>Ceram, ka BRIDGESTONE PLUS jums sniegs panākumus un vērtīgas iespējas, un mēs gaidām turpmāku sadarbību.<br/>Ar cieņu,<br/>BRIDGESTONE PLUS komanda",
    },
    uberall: { title: "", content: "" },
    welcome: {
      title: "Paldies par reģistrēšanos",
      content:
        "Cienījamais,<br/>Paldies par reģistrēšanos. Mēs ar prieku informējam, ka jūsu reģistrācija BRIDGESTONE PLUS ir pārskatīta un apstiprināta.<br/>Ceram, ka BRIDGESTONE PLUS jums sniegs panākumus un vērtīgas iespējas, un mēs gaidām turpmāku sadarbību.<br/>Ar cieņu,<br/>BRIDGESTONE PLUS komanda",
    },
    booster: { title: "", content: "" },
    orderStatus_RETURNED: { title: "", content: "" },
    orderStatus_REJECTED: { title: "", content: "" },
    kickbackPayback: { title: "", content: "" },
    survey_thankyou: { title: "", content: "" },
    survey: { title: "", content: "" },
    salesPromotions: { title: "", content: "" },
  },
};

export default {
  messages,
};
